import { render, staticRenderFns } from "./qrAppointmentsList.vue?vue&type=template&id=4b8c213a&scoped=true"
import script from "./qrAppointmentsList.vue?vue&type=script&lang=js"
export * from "./qrAppointmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c213a",
  null
  
)

export default component.exports